<template>
  <div style="background: #f7f8fa">
    <my-head></my-head>
    <div class="valuation-review minH">
      <div class="crumbs">
        首页 > 知产质押融资 >
        <span style="color: #1d2129">质押融资详情</span>
      </div>

      <div class="valuation_form">
        <div class="form-title">质押融资详情</div>

                 <!-- 第一步：基本信息 -->
         <div>
          <el-form ref="form" :model="form" label-position="top" label-width="80px">
            <!-- 1. 企业全称 -->
            <el-form-item label="企业全称 (营业执照上的名称)*">
              <el-input v-model="form.qyqc" readonly style="width: 100%;"></el-input>
            </el-form-item>

            <!-- 2. 企业联系人和联系方式 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="企业联系人*">
                  <el-input v-model="form.qylxr" readonly style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式*">
                  <el-input v-model="form.lxfs" readonly style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

                         <!-- 4. 拟融资规模 -->
             <el-form-item label="拟融资规模 (单位:万元)*">
               <el-input v-model="form.nrzgm" readonly style="width: 100%;">
                 <template slot="append">万</template>
               </el-input>
             </el-form-item>

            <!-- 5. 企业简介 -->
            <el-form-item label="企业简介*">
              <el-input 
                type="textarea" 
                v-model="form.qyjj" 
                readonly
                :rows="4"
                style="width: 100%;">
              </el-input>
            </el-form-item>

            <!-- 6. 专利明细列表 -->
            <el-form-item label="企业拟用于本次事宜的专利明细列表 (已授权,剩余寿命大于等于5年,填写1-5项)*">
              <div class="patent-table">
                <el-table :data="form.zlml" border style="width: 100%">
                  <el-table-column prop="serial" label="序号" width="80" align="center"></el-table-column>
                  <el-table-column prop="name" label="专利名称" min-width="300"></el-table-column>
                  <el-table-column prop="type" label="专利类型" width="120"></el-table-column>
                  <el-table-column prop="applicationNumber" label="申请号" width="150"></el-table-column>
                </el-table>
              </div>
            </el-form-item>

            <!-- 7. 无形资产与企业产品/服务的对应关系 -->
            <el-form-item label="拟估值的无形资产与企业产品/服务的对应关系 (简要说明,300字以内)*">
              <el-input 
                type="textarea" 
                v-model="form.wxcps" 
                readonly
                :rows="4"
                style="width: 100%;">
              </el-input>
            </el-form-item>

            <!-- 8. 历史财务信息 -->
            <el-form-item label="历史财务信息 (基准日前三年及最新一期) 万元">
              <div class="financial-table">
                <el-table :data="historicalFinanceData" border style="width: 100%">
                  <el-table-column prop="name" label="" min-width="120"></el-table-column>
                  <el-table-column 
                    v-for="(year, yearIndex) in historicalYears" 
                    :key="yearIndex"
                    :label="`${year}年`" 
                    min-width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.values[yearIndex] !== null && scope.row.values[yearIndex] !== undefined ? scope.row.values[yearIndex] : '' }}万</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>

            <!-- 9. 未来五年财务预测 -->
            <el-form-item label="未来五年的财务预测情况万元 (选填)">
              <div class="financial-table">
                <el-table :data="futureFinanceData" border style="width: 100%">
                  <el-table-column prop="name" label="" min-width="120"></el-table-column>
                  <el-table-column 
                    v-for="(year, yearIndex) in futureYears" 
                    :key="yearIndex"
                    :label="`${year}年`" 
                    min-width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.values[yearIndex] !== null && scope.row.values[yearIndex] !== undefined ? scope.row.values[yearIndex] : '' }}万</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>
        </div>

                 <!-- 第二步：银行资料 -->
         <div v-if="hasBankInfo">
          <el-form ref="bankForm" :model="bankForm" label-position="top" label-width="80px">
            <!-- 银行资料表单 -->
            <el-form-item label="1. 贷款行全称*" prop="dkhqc">
              <el-input 
                v-model="bankForm.dkhqc" 
                readonly
                style="width: 100%;">
              </el-input>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="2. 客户经理姓名*" prop="khjlxm">
                  <el-input 
                    v-model="bankForm.khjlxm" 
                    readonly
                    style="width: 100%;">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户经理联系方式*" prop="khjllxfs">
                  <el-input 
                    v-model="bankForm.khjllxfs" 
                    readonly
                    style="width: 100%;">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 重新提交按钮（退回状态时显示） -->
        <div v-if="isRejected" style="text-align: center; margin-top: 32px; padding-top: 24px; border-top: 1px solid #e5e6eb;">
          <el-button type="primary" size="medium" @click="resubmit">重新提交</el-button>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";

export default {
  name: 'ValuationDetail',
  components: { MyHead, MyFooter },
  data() {
    return {
      lastMonth: this.getLastMonth(),
      hasBankInfo: false,
      status: null, // 申请状态
      form: {
        qyqc: '', // 企业全称
        qylxr: '', // 企业联系人
        lxfs: '', // 联系方式
        nrzgm: '', // 拟融资规模
        qyjj: '', // 企业简介
        wxcps: '', // 无形资产与企业产品/服务的对应关系
        zlml: [], // 专利明细列表
        lscwxx: null, // 历史财务信息原始数据
        wlnwcw: null // 未来五年财务预测原始数据
      },
      historicalYears: [], // 历史财务信息年份
      historicalFinanceData: [], // 历史财务信息表格数据
      futureYears: [], // 未来财务预测年份
      futureFinanceData: [], // 未来财务预测表格数据
      bankForm: {
        dkhqc: '', // 贷款行全称
        khjlxm: '', // 客户经理姓名
        khjllxfs: '' // 客户经理联系方式
      }
    }
  },
  computed: {
    // 判断是否是退回状态（状态2：金融部审核退回，状态4：银行已拒绝）
    isRejected() {
      return this.status === 2 || this.status === 4;
    }
  },
  mounted() {
    // 获取要查看的数据
    this.getDetailData();
  },
  methods: {
    getLastMonth() {
      const now = new Date();
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      return lastMonth.getMonth() + 1 + '月';
    },
    getDetailData() {
      // 从路由参数获取申请ID
      const applicationId = this.$route.params.id;
      if (applicationId) {
        getRequest({
          url: `/api/v1/valuation-form/${applicationId}`
        }).then((res) => {
          this.form = res.data;
          this.status = res.data.status; // 保存状态
          // 解析JSON字符串
          if (typeof this.form.zlml === 'string') {
            this.form.zlml = JSON.parse(this.form.zlml);
          }
          
          // 解析历史财务信息
          if (typeof this.form.lscwxx === 'string') {
            const lscwxxData = JSON.parse(this.form.lscwxx);
            this.form.lscwxx = lscwxxData;
            // 提取年份和指标数据
            if (lscwxxData && lscwxxData.years) {
              this.historicalYears = lscwxxData.years;
            }
            if (lscwxxData && lscwxxData.indicators) {
              this.historicalFinanceData = lscwxxData.indicators;
            }
          } else if (this.form.lscwxx) {
            // 如果已经是对象，直接使用
            if (this.form.lscwxx.years) {
              this.historicalYears = this.form.lscwxx.years;
            }
            if (this.form.lscwxx.indicators) {
              this.historicalFinanceData = this.form.lscwxx.indicators;
            }
          }
          
          // 解析未来五年财务预测
          if (typeof this.form.wlnwcw === 'string') {
            const wlnwcwData = JSON.parse(this.form.wlnwcw);
            this.form.wlnwcw = wlnwcwData;
            // 提取年份和指标数据
            if (wlnwcwData && wlnwcwData.years) {
              this.futureYears = wlnwcwData.years;
            }
            if (wlnwcwData && wlnwcwData.indicators) {
              this.futureFinanceData = wlnwcwData.indicators;
            }
          } else if (this.form.wlnwcw) {
            // 如果已经是对象，直接使用
            if (this.form.wlnwcw.years) {
              this.futureYears = this.form.wlnwcw.years;
            }
            if (this.form.wlnwcw.indicators) {
              this.futureFinanceData = this.form.wlnwcw.indicators;
            }
          }
          
          // 如果有银行信息，显示银行信息部分
          if (res.data.dkhqc || res.data.khjlxm || res.data.khjllxfs) {
            this.bankForm.dkhqc = res.data.dkhqc || '';
            this.bankForm.khjlxm = res.data.khjlxm || '';
            this.bankForm.khjllxfs = res.data.khjllxfs || '';
            this.hasBankInfo = true;
          }
        }).catch((error) => {
          console.error('获取详情数据失败:', error);
          this.$message.error('获取详情数据失败');
        });
      }
    },
    // 重新提交：跳转到表单页面并传递当前数据ID
    resubmit() {
      const applicationId = this.$route.params.id;
      this.$router.push({
        name: 'valuationform',
        query: {
          editId: applicationId
        }
      });
    }
  }
}
</script>

<style lang="scss">
.valuation-review {
  width: 80%;
  margin: 48px auto 60px;

  .crumbs {
    font-size: 14px;
    color: #86909c;
    margin-bottom: 20px;
  }

  .valuation_form {
    padding: 24px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e6eb;
    
    .form-title {
      font-size: 20px;
      font-weight: bold;
      color: #1d2129;
      line-height: 32px;
      text-align: left;
      margin-bottom: 32px;
      padding-bottom: 16px;
      border-bottom: 1px solid #e5e6eb;
    }

    .patent-table, .financial-table {
      margin-top: 10px;
    }

    .el-form-item {
      margin-bottom: 25px;

      .el-form-item__label {
        font-weight: normal;
        color: #333;
      }
    }

    .el-table {
      // 表头样式
      .el-table__header-wrapper {
        .el-table__header {
          th {
            background-color: #f5f7fa !important;
            color: #333;
            font-weight: normal;
          }
        }
      }
      
      // 调整行高
      .el-table__body-wrapper {
        .el-table__body {
          td {
            padding: 8px 0;
          }
        }
      }
      
      // 表格内输入框样式
      .el-input {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      
      // 表格内选择框样式
      .el-select {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      
      // 表格内输入框后缀样式
      .el-input-group__append {
        background-color: transparent !important;
        border: none !important;
        color: #333;
        padding: 0 8px;
      }
    }
  }
}

.minH {
  min-height: calc(100vh - 200px);
}
</style>
